import { suitcase, objectGroup, areaChart, trophy } from 'react-icons-kit/fa'

const Servicedata = [
  {
    id: 1,
    Icon: suitcase,
    title: 'Our Perspective:',
    content: 'We have the expertise and a global network of senior telco and digital consultants with deep telecommunications experience.'
  },
  {
    id: 2,
    Icon: objectGroup,
    title: 'Our Approach:',
    content: 'Your business is our business. We believe in making your dreams and goals a reality and our experts know just how to do that.'
  }
]

const Servicedata1 = [
  {
    id: 1,
    Icon: areaChart,
    title: 'Our Mission and belief',
    content: 'We believe that bold steps define the future. That the ambition to lead requires the courage to adapt. And that doing the right thing is rarely easy, but always worth it.'
  },
  {
    id: 2,
    Icon: trophy,
    title: 'Experience',
    content: 'We have vast depth of experience and can help your business grow with our technology.'
  }
]

export { Servicedata, Servicedata1 }
